import { Box, Link } from '@flos/react-ui';
import useAppState from '../../state/appState';
import { CarbucksPage as CarbucksPageType, FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { trackInteract } from '../../track-by-submit/common/tracking';
import { useNavigate } from 'react-router-dom';
import { useRef, useEffect } from 'react';

const CarbucksPage = ({ elementId, caption, values }: CarbucksPageType) => {
    const formConfig = useAppState((state) => state.formConfig);
    const navigate = useNavigate();

    const hasInteracted = useRef(sessionStorage.getItem('hasInteracted') === 'true');

    useEffect(() => {
        const handleUnload = () => {
            if (!hasInteracted.current && formConfig) {
                trackInteract(formConfig, [{ key: 'damage-handling', value: 'left-without-choosing' }]);
            }
        };

        window.addEventListener('beforeunload', handleUnload);
        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, [hasInteracted, formConfig]);

    const handleInteraction = (action: string, formConfig: FormConfig) => {
        hasInteracted.current = true;
        sessionStorage.setItem('hasInteracted', 'true');
        trackInteract(formConfig, [{ key: 'damage-handling', value: action }]);
    };

    if (!formConfig) {
        return <></>;
    }
    const url = values.length > 0 ? values[0].url : undefined;

    return (
        <>
            <h4>{caption}</h4>
            <div className="Box--group">
                <Box
                    padding="large"
                    actionArea={
                        <Link
                            hasIcon={true}
                            theme="logo"
                            onClick={() => {
                                handleInteraction('redirect-to-carbucks', formConfig);
                                if (url) {
                                    window.location.href = url;
                                }
                            }}
                        >
                            Book tid til reparation
                        </Link>
                    }
                    style={{ background: '#131947', color: '#f7f7f7', border: '#131947', textAlign: 'center' }}
                >
                    <h4>Bule eller ridse i lakken?</h4>
                    <p>
                        Få udbedret skaden på kun 2 timer hos vores samarbejdspartner Carbucks. Alt du skal gøre er at
                        booke tid – så klarer vi det praktiske, og du er hurtigt tilbage på vejen.
                    </p>
                </Box>
                <Box
                    padding="large"
                    actionArea={
                        <Link
                            hasIcon={true}
                            theme="logo"
                            onClick={() => {
                                handleInteraction('continue-with-form', formConfig);
                                navigate(`/${formConfig.formId}/godt-at-vide`);
                            }}
                        >
                            Fortsæt til anmeldelse
                        </Link>
                    }
                    style={{ textAlign: 'center' }}
                >
                    <h4>Skaden står værre til</h4>
                    <p>
                        Har din bil fået en større skade? Anmeld det til os her og vælg et af vores fordelsværksteder,
                        hvor vi står for alt det praktiske – og du får lånebil, rengøring, bilvask og udvidet garanti
                        undervejs.
                    </p>
                </Box>
            </div>
        </>
    );
};

CarbucksPage.isValid = (formConfig: FormConfig, formValues: FormValues, elementId: string): boolean => {
    return true;
};

export default CarbucksPage;
